import React from 'react'
import { useRouter } from 'next/router'

import PageProps from '@/interfaces/page'
import { H2 } from '@/components/typography'
import Section from '@/layouts/section'

// this HOC is used as a fallback when a new detail page is published. In this case, NextJS will render it server side. 
// While this is happening, the fallback is rendered.
export default function WithFallback<T>(Component: React.FC<PageProps<T>>) {
  return function Page(componentProps: PageProps<T>) {
    const { isFallback } = useRouter()

    if (isFallback) {
      return (
        <Section>
          <H2>loading...</H2>
        </Section>
      )
    }

    return <Component {...componentProps} />
  }
}
